import React from 'react';
import { Link } from 'react-router-dom';
import { Construction, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Header } from '../components/Header';

export default function ToolPlaceholder({ title = 'Tool', description = 'This tool is being built.' }) {
  return (
    <>
      <Header />
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center mx-auto mb-6">
          <Construction className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">{title}</h1>
        <p className="text-gray-600 mb-8">{description}</p>
        <Link to="/"><Button variant="outline" className="gap-2"><ArrowLeft className="w-4 h-4" /> Back to Dashboard</Button></Link>
      </div>
    </>
  );
}
